import { IonButton, IonIcon } from '@ionic/react';
import React from 'react';

import ButtonContainer from '@/components/common/buttonContainer/ButtonContainer';
import Spacer from '@/components/common/spacer/Spacer';
import Selection from '@/components/selection/Selection';
import { useClinicGroup } from '@/contexts/ClinicGroupContext';
import { Clinic } from '@/data/Clinics';
import useToast from '@/hooks/useToast';
import { arrowForwardCircleOutline, locationOutline } from 'ionicons/icons';

import './SelectBranch.css';

const SelectBranch: React.FC = () => {
  const displayToast = useToast();
  const {
    branches,
    clinicGroup,
    selectedBranch,
    setSelectedBranch,
    onSelectBranch
  } = useClinicGroup();

  if (!clinicGroup) return null;

  const copy = {
    subHeader: 'SELECT A BRANCH',
    header: clinicGroup.name,
    message:
      'To proceed with scheduling your appointment, please select your preferred branch.',
    buttonText: 'Next'
  };

  const getLabel = (clinic: Clinic) => {
    return clinic.name;
  };

  const isSelected = (clinic: Clinic) => clinic.id === selectedBranch?.id;

  const onNext = () => {
    if (selectedBranch) {
      onSelectBranch(selectedBranch.id!);
    } else {
      displayToast({
        message: `Please select a branch to proceed.`,
        duration: 2400,
        position: 'bottom',
        positionAnchor: 'nextButton'
      });
    }
  };

  return (
    <div id="selectBranch">
      <IonIcon color="primary" icon={locationOutline} id="selectBranchIcon" />
      <h4 id="subHeader">{copy.subHeader}</h4>
      <h1 id="header">{copy.header}</h1>
      <p id="message">{copy.message}</p>
      <Spacer top={24} bottom={102}>
        <Selection
          options={branches}
          getLabel={getLabel}
          onClick={setSelectedBranch}
          isSelected={isSelected}
        />
      </Spacer>
      <ButtonContainer>
        <IonButton
          id="nextButton"
          onClick={onNext}
          expand="block"
          fill="solid"
          size="default"
          color="primary"
          strong={true}
        >
          <IonIcon slot="start" icon={arrowForwardCircleOutline}></IonIcon>
          {copy.buttonText}
        </IonButton>
      </ButtonContainer>
    </div>
  );
};

export default SelectBranch;
